import Vue from 'vue'
import App from '@/App'
import Element from 'element-ui'
import Meta from 'vue-meta'
import locale from 'element-ui/lib/locale/lang/en'
import router from '@/routes'
import store from '@/store'
import auth from '@/services/auth'
import '@/styles/style.scss'
import '@/styles/element.scss'
import VueI18n from 'vue-i18n'
import i18n from './i18n'
import globalMixin from '@/mixins/globalMixin'
import closable from '@/directives/closable'
import { formatDate, formatFolderName, formatRootFolderName } from '@/filters/filters'
import ElTableInfiniteScroll from 'el-table-infinite-scroll'

Vue.config.productionTip = false
Vue.use(Element, { locale })
Vue.use(Meta)
Vue.use(VueI18n)
Vue.mixin(globalMixin)
Vue.filter('formatDate', formatDate)
Vue.filter('formatFolderName', formatFolderName)
Vue.filter('formatRootFolderName', formatRootFolderName)

Vue.directive('closable', closable)
Vue.directive('el-table-infinite-scroll', ElTableInfiniteScroll)

Object.defineProperty(Vue.prototype, '$hasRole', {
  value: function (roles) {
    return auth.hasRole(roles)
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
